import { BrowserRouter } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";

function AppRouter() {
    return (
        <BrowserRouter>
            <PublicRoutes />
        </BrowserRouter>
    );
}

export default AppRouter;
